module.exports = __webpack_public_path__ + "img/error.0aa4cd86.png";